/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ButtonProps } from "@insite/mobius/Button";
import { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import Trash from "@monsma/XDL/Icons/Trash";
import { css } from "styled-components";

export const titleGridItems: GridItemProps = {
    width: [10, 10, 8, 8, 8],
};

export const buttonsGridItem: GridItemProps = {
    width: [2, 2, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        align-items: center;
    `,
};

export const cancelButton: ButtonProps = { variant: "secondary" };

export const removeIcon = {
    src: Trash,
    color: "common.ui17",
    size: 13,
    css: css`
        display: block;
        cursor: pointer;
        margin: auto;

        &.active,
        &:hover {
            &&& * {
                color: ${getColor("common.ui16")};
            }
        }
    `,
};

export const bottomButtonsGridItem: GridItemProps = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
    `,
};
